"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Ranking;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Ranking(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "ranking"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M45.1,19.467l3.425-3.424v15.3a2.5,2.5,0,0,0,5,0V10a2.487,2.487,0,0,0-1.644-2.309,2.56,2.56,0,0,0-2.687.611l-7.629,7.63A2.5,2.5,0,1,0,45.1,19.467Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.023,66.161a8.147,8.147,0,1,0,3.146,15.66v2.533A3.15,3.15,0,0,1,51.023,87.5H45.376a2.5,2.5,0,0,0,0,5h5.647a8.155,8.155,0,0,0,8.146-8.146V74.308A8.156,8.156,0,0,0,51.023,66.161Zm0,11.294a3.147,3.147,0,1,1,3.146-3.147A3.151,3.151,0,0,1,51.023,77.455Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.023,37.316a2.592,2.592,0,1,0,2.592,2.592A2.591,2.591,0,0,0,51.023,37.316Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.023,47.44a2.593,2.593,0,1,0,2.592,2.592A2.592,2.592,0,0,0,51.023,47.44Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.023,57.565a2.592,2.592,0,1,0,2.592,2.592A2.592,2.592,0,0,0,51.023,57.565Z"
  })))));
}